export default __webpack_public_path__ + "static/ThisIsTimberline_1-e6b59c37da5aa0b77a4bc5f2f2e7cf52.mp4";